import React from "react";
import { getHomeData } from "../data/home.js";
import "../pages/homePage/homePage.css";
import Marquee from "react-fast-marquee";

const LogoMarquee = () => {
  const homeData = getHomeData();
  
  return (
    <section className="logo-section py-2 mb-3 mb-md-5">
      <Marquee>
        {homeData.marque.map((item) => (
          <img
            key={item.id}
            src={item.image}
            alt="logo"
            className="marquee-logo"
          />
        ))}
      </Marquee>
    </section>
  );
};

export default LogoMarquee;